import pluralize from 'pluralize'

const pluralizeStrBasedOnNumber = (number, str) => {
  if (!number) return pluralize(str)
  return Number(number) > 1 || Number(number) === 0 ? pluralize(str) : str
}

export default pluralizeStrBasedOnNumber
